import { useMutation, useQueryClient } from 'react-query'

import { IUpdateAccountIndustryDto } from 'src/types'
import { QUERY_KEYS } from 'src/constants'
import { accountIndustryService } from 'src/services/account-industry.service'

export const useUpdateAccountIndustry = () => {
  const queryClient = useQueryClient()

  return useMutation(
    async (item: IUpdateAccountIndustryDto) => {
      return accountIndustryService.updateIndustry(item)
    },
    {
      onSuccess: (data) => {
        if (data) {
          queryClient.invalidateQueries(QUERY_KEYS.ACCOUNT_INDUSTRIES)
        }
      },
    },
  )
}
